import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/docbrain1.png'


const _hoisted_1 = { class: "login-page d-flex align-items-center" }
const _hoisted_2 = { class: "container py-5" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4 login-shell" }
const _hoisted_5 = { class: "card shadow-lg border-0 rounded-4 overflow-hidden" }
const _hoisted_6 = { class: "card-body p-4 p-md-4" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = ["type", "disabled"]
const _hoisted_13 = ["disabled", "aria-label"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_17 = { class: "form-check" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "alert alert-success py-2 small",
  role: "alert"
}
const _hoisted_20 = {
  key: 1,
  class: "alert alert-danger py-2 small",
  role: "alert"
}
const _hoisted_21 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "d-inline-flex align-items-center gap-2"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "d-flex justify-content-between align-items-center mt-3" }
const _hoisted_27 = { class: "card-footer bg-light border-0 py-3 px-4" }
const _hoisted_28 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_29 = { class: "small text-muted" }

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import api from '@/api'
import { renderGoogleButton } from '@/services/googleIdentity'
import { getRecaptchaToken } from '@/services/recaptcha'

// 👇 Ajustá el logo a donde lo tengas.
// Recomendación: poner el logo en /src/assets/docbrain-logo.png


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const router = useRouter()
const store = useStore()

const usuario = ref('')
const contrasena = ref('')
const success = ref('')
const error = ref('')
const loading = ref(false)
const resendingVerification = ref(false)
const remember = ref(true)
const showPassword = ref(false)
const canResendVerification = ref(false)
const googleButtonRef = ref<HTMLElement | null>(null)

const login = async () => {
  error.value = ''
  success.value = ''
  canResendVerification.value = false
  loading.value = true

  try {
    const recaptchaToken = await getRecaptchaToken('login')

    const res = await api.post('/auth/login', {
      email: usuario.value,
      password: contrasena.value,
      recaptcha_token: recaptchaToken
    })

    // Guardado simple (igual que tenías). Si querés token, lo acomodamos.
    store.commit('setAuth', {
      token: res.data.access_token,
      user: res.data.user
    })

    // Si querés “recordarme” real: guardar usuario (o token) con expiración, etc.
    if (remember.value) {
      localStorage.setItem('docbrain_user', usuario.value)
    } else {
      localStorage.removeItem('docbrain_user')
    }

    router.push('/dashboard')
  } catch (e: any) {
    error.value = e?.response?.data?.detail || e?.message || 'Usuario o contraseña incorrectos'
    canResendVerification.value = e?.response?.data?.detail === 'Cuenta no verificada. Revisá tu email.'
  } finally {
    loading.value = false
  }
}

const loginWithGoogle = async (credential: string) => {
  error.value = ''
  success.value = ''
  canResendVerification.value = false
  loading.value = true

  try {
    const res = await api.post('/auth/google', { credential })

    store.commit('setAuth', {
      token: res.data.access_token,
      user: res.data.user
    })

    localStorage.setItem('docbrain_user', res.data.user.email)
    router.push('/dashboard')
  } catch (e: any) {
    error.value = e?.response?.data?.detail || e?.message || 'No se pudo iniciar sesión con Google'
  } finally {
    loading.value = false
  }
}

onMounted(async () => {
  if (!googleButtonRef.value) return

  try {
    await renderGoogleButton(googleButtonRef.value, loginWithGoogle)
  } catch (e: any) {
    error.value = e?.message || 'No se pudo cargar Google Sign-In'
  }
})

const resendVerification = async () => {
  error.value = ''
  success.value = ''
  resendingVerification.value = true

  try {
    const res = await api.post('/auth/resend-verification', {
      email: usuario.value
    })
    success.value = res?.data?.message || 'Correo de activación reenviado.'
    canResendVerification.value = false
  } catch (e: any) {
    error.value = e?.response?.data?.detail || 'No se pudo reenviar el correo de activación.'
  } finally {
    resendingVerification.value = false
  }
}

const forgotPassword = () => {
  // Placeholder. Acá podés abrir modal, ir a /reset-password, etc.
  error.value = 'Función de recuperación pendiente de implementación.'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-center" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "DocBrain",
              class: "brand-logo"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"d-flex align-items-start justify-content-between mb-3\" data-v-6a007180><div data-v-6a007180><h2 class=\"h5 fw-bold mb-1\" data-v-6a007180>Ingresar</h2><p class=\"text-muted mb-0 small\" data-v-6a007180> Accedé a tu panel de forma segura. </p></div><div class=\"secure-badge d-flex align-items-center gap-2\" data-v-6a007180><span class=\"lock-dot\" aria-hidden=\"true\" data-v-6a007180></span><span class=\"small text-muted\" data-v-6a007180>Conexión segura</span></div></div>", 1)),
              _createElementVNode("form", {
                onSubmit: _withModifiers(login, ["prevent"]),
                novalidate: ""
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", {
                    for: "usuario",
                    class: "form-label"
                  }, "Email", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "input-group-text bg-white" }, [
                      _createElementVNode("svg", {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("path", {
                          d: "M20 21a8 8 0 1 0-16 0",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        })
                      ])
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((usuario).value = $event)),
                      type: "text",
                      class: "form-control",
                      id: "usuario",
                      autocomplete: "username",
                      required: "",
                      disabled: loading.value,
                      placeholder: "tu@email.com"
                    }, null, 8, _hoisted_9), [
                      [
                        _vModelText,
                        usuario.value,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", {
                    for: "contrasena",
                    class: "form-label"
                  }, "Contraseña", -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "input-group-text bg-white" }, [
                      _createElementVNode("svg", {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("path", {
                          d: "M7 11V8a5 5 0 0 1 10 0v3",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M6 11h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        })
                      ])
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contrasena).value = $event)),
                      type: showPassword.value ? 'text' : 'password',
                      class: "form-control",
                      id: "contrasena",
                      autocomplete: "current-password",
                      required: "",
                      disabled: loading.value,
                      placeholder: "••••••••"
                    }, null, 8, _hoisted_12), [
                      [_vModelDynamic, contrasena.value]
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value)),
                      disabled: loading.value,
                      "aria-label": showPassword.value ? 'Ocultar contraseña' : 'Mostrar contraseña',
                      title: "Mostrar/Ocultar"
                    }, [
                      (!showPassword.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Mostrar"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_15, "Ocultar"))
                    ], 8, _hoisted_13)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "remember",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((remember).value = $event)),
                      disabled: loading.value
                    }, null, 8, _hoisted_18), [
                      [_vModelCheckbox, remember.value]
                    ]),
                    _cache[9] || (_cache[9] = _createElementVNode("label", {
                      class: "form-check-label small",
                      for: "remember"
                    }, " Recordarme ", -1))
                  ]),
                  _createElementVNode("a", {
                    class: "small text-decoration-none",
                    href: "#",
                    onClick: _withModifiers(forgotPassword, ["prevent"])
                  }, " ¿Olvidaste tu contraseña? ")
                ]),
                (success.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(success.value), 1))
                  : _createCommentVNode("", true),
                (error.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(error.value), 1))
                  : _createCommentVNode("", true),
                (canResendVerification.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-outline-primary",
                        onClick: resendVerification,
                        disabled: loading.value || resendingVerification.value || !usuario.value
                      }, _toDisplayString(resendingVerification.value ? 'Reenviando…' : 'Reenviar correo de activación'), 9, _hoisted_22)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary w-100 py-2 fw-semibold",
                  disabled: loading.value || !usuario.value || !contrasena.value
                }, [
                  (loading.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _cache[10] || (_cache[10] = [
                        _createElementVNode("span", {
                          class: "spinner-border spinner-border-sm",
                          role: "status",
                          "aria-hidden": "true"
                        }, null, -1),
                        _createTextVNode(" Verificando… ")
                      ])))
                    : (_openBlock(), _createElementBlock("span", _hoisted_25, "Ingresar"))
                ], 8, _hoisted_23),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "position-relative my-3" }, [
                  _createElementVNode("hr", { class: "my-0" }),
                  _createElementVNode("span", { class: "auth-separator text-muted small" }, "o")
                ], -1)),
                _createElementVNode("div", {
                  ref_key: "googleButtonRef",
                  ref: googleButtonRef,
                  class: _normalizeClass(["google-button-slot", { 'is-disabled': loading.value }])
                }, null, 2),
                _createElementVNode("div", _hoisted_26, [
                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-muted small" }, "¿No tenés cuenta?", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push('/registrarse')))
                  }, " Registrarse ")
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-center mt-3" }, [
                  _createElementVNode("p", { class: "text-muted small mb-0" }, " Al ingresar aceptás las políticas de seguridad de la plataforma. ")
                ], -1))
              ], 32)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("span", _hoisted_29, "© " + _toDisplayString(new Date().getFullYear()) + " DocBrain", 1),
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "small text-muted d-flex align-items-center gap-2" }, [
                  _createElementVNode("span", {
                    class: "shield",
                    "aria-hidden": "true"
                  }),
                  _createTextVNode(" TLS / HTTPS ")
                ], -1))
              ])
            ])
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-center mt-4" }, [
            _createElementVNode("span", { class: "text-white-50 small" }, " ¿Necesitás acceso? Contactá al administrador. ")
          ], -1))
        ])
      ])
    ])
  ]))
}
}

})